module.exports = __webpack_public_path__ + "static/media/188.7df7af76.webp";